import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AvatarSize } from '@freelancer/ui/user-avatar';

@Component({
  selector: 'fl-user-search-card-loading',
  template: `
    <div
      class="AvatarRow"
      [flMarginBottom]="'xsmall'"
    >
      <fl-user-avatar
        [flMarginRight]="'small'"
        class="UserAvatar"
        [size]="AvatarSize.LARGE"
        [users]="[undefined]"
      ></fl-user-avatar>
      <div class="AvatarRow-description">
        <fl-loading-text
          class="AvatarRow-loading"
          [padded]="false"
          [rows]="2"
          [flMarginBottom]="'xsmall'"
        ></fl-loading-text>
        <fl-loading-text
          [padded]="false"
          [rows]="4"
        ></fl-loading-text>
      </div>
    </div>
  `,
  styleUrls: ['./user-search-card-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSearchCardLoadingComponent {
  AvatarSize = AvatarSize;
}
